<template>
    <el-table border size="mini" :data="list" style="width: 100%">
        <el-table-column prop="ddzt" label="状态" :formatter="formatter"></el-table-column>
        <el-table-column prop="ghrq" label="预约日期"></el-table-column>
        <el-table-column prop="numno" label="预约号"></el-table-column>
        <el-table-column prop="numtime" label="预估就诊时间" ></el-table-column>
        <el-table-column prop="hzxm" label="患者"></el-table-column>
        <el-table-column prop="hosPatid" label="就诊卡号"></el-table-column>
        <el-table-column prop="sjh" label="手机号"></el-table-column>
        <el-table-column prop="ksmc" label="预约科室"></el-table-column>
        <el-table-column prop="ysmc" label="预约医生"></el-table-column>
        <el-table-column label="操作" min-width="140">
            <template slot-scope="{row}">
                <el-button type="text" @click="handler(row)">查看资料</el-button>
                <el-button v-if="showRecord" type="text" @click="record(row)">查看病历</el-button>
            </template>
        </el-table-column>
    </el-table>
</template>

<script>
    import {ONLINE_DDZT} from "../../lib/config";

    export default {
        name: "online-table",
        props: {
            list: {
                type: Array,
                default: () => {
                    return [];
                },
            },
            showRecord: {
                type: Boolean,
                default: true,
            }
        },
        methods: {
            handler(data) {
                this.$router.push({
                    path: '/main/online/detail',
                    query: {id: data.ddid}
                })
            },
            record(data){
                this.$emit('showRecord', data)
            },
            formatter(row, column, cell, index) {
                return ONLINE_DDZT[cell] ? ONLINE_DDZT[cell].name : cell;
            }
        },
    }
</script>

<style scoped>

</style>
